/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../api/index';
import * as core from '../../../../core';
import * as serializers from '../../../index';

export const CredentialSignRequestDidMethod: core.serialization.Schema<
    serializers.CredentialSignRequestDidMethod.Raw,
    Truvity.CredentialSignRequestDidMethod
> = core.serialization.enum_(['key', 'web']);

export declare namespace CredentialSignRequestDidMethod {
    export type Raw = 'key' | 'web';
}
